import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Discount = () => {
    document.title = "Sənədlərdə endirim";
    
    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sənədlərdə endirim", value: "/common/discount", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədlərdə endirim</h2>
                    <p>
                        Həm bütün məhsullara həm də bir neçə məhsula endirim təyin etmək üçün nəzərdə tutulub.
                        <br />
                        <b>Qeyd: </b>Ümumi endirim təyin olunduqda, ayrı aryılıqda məhsula tətbiq edilən endirim silinib ümumi endirim tətbiq ediləcək.
                    </p>
                    <img src="/images/common/discount.gif" alt="Sənədlərdə endirim" />
                </article>
            </div>
        </div>
    );
};
